<template>
  <div class="page-box traffic-page">
    <!--查询条件 -->
    <query-condition-box class="header">
      <datePicker :hasCurrent="1" @changeDate="changeDate"></datePicker>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="exportList"
        >导出
      </el-button>
    </query-condition-box>
    <!-- 列表展示 -->
    <div class="result-container" v-loading="loading">
      <!-- 数据统计模块 -->
      <dataStatistics
        :type="'traffic'"
        :showInfo="showInfo"
        @changeData="changeShow"
      ></dataStatistics>
      <div class="echarts-box">
        <div id="main"></div>
        <div id="circular"></div>
      </div>
    </div>
  </div>
</template>

<script>
import dataStatistics from "../../components/operate/data-statistics.vue";
import datePicker from "../../components/common/date-picker.vue";
import * as echarts from "echarts";
import api from "@/assets/js/api";
export default {
  data() {
    return {
      //查询参数
      queryParams: {
        from: "",
        to: "",
      },
      shopViewCnt: 0, // 店铺浏览量
      shopViewCntList: [], // 店铺浏览量数据列表
      shopVisitorCnt: 0, // 店铺访客数
      shopVisitorCntList: [], // 店铺访客数数据列表
      shopContentViewCnt: 0, // 内容浏览量
      shopContentViewCntList: [], // 内容浏览量数据列表
      shopContentVisitorCnt: 0, // 内容访客数
      shopContentVisitorCntList: [], // 内容访客数数据列表
      showInfo: [], // 数据统计模块展示的数据
      distribution: {}, // 渠道饼状图渲染数据
      showType: 0, // 类型筛选项  2-店铺浏览量 5-店铺访客数 6-内容浏览量 7-内容访客数
      currentTypeInfo: {}, // 当前显示的类型的信息数据
      channel: 0, // 渠道筛选项 100-全部 101-PC 102-H5 103-APP
      channelName: "", // 渠道筛选项名称
      channelInfo: {
        PC: 0,
        H5: 0,
        APP: 0,
      }, // 渠道饼状图渲染数据
      channelColors: {
        PC: "#6384f7",
        H5: "#64f28c",
        APP: "#ff92ae",
      }, // 渠道数据对应的渲染颜色
      loading: false,
    };
  },
  components: {
    dataStatistics,
    datePicker,
  },
  mounted() {},

  methods: {
    // 切换时间段
    changeDate(e) {
      this.showType = 0;
      this.channel = 0;
      this.distribution = {};
      this.currentTypeInfo = {};
      this.queryParams.from = e.startTime;
      this.queryParams.to = e.endTime;
      // this.queryParams = e;
      this.queryList();
    },
    // 切换图表显示的数据
    changeShow(e) {
      // console.log("切换显示的数据为---", e);
      let dataList = [];
      // 如果切换的是数据类型
      if (this.showType !== e.id1) {
        this.showType = e.id1;
        this.channel = e.id2;
        this.channelName = e.label2;
        // 选择不限渠道，则显示全部数据
        dataList = this.showAllChannel();
      } else if (this.channel !== e.id2) {
        // 如果仅仅切换的是渠道
        this.channel = e.id2;
        this.channelName = e.label2;
        // 如果是不限渠道，则显示全部数据
        if (this.channel === 100) {
          dataList = this.showAllChannel();
        } else {
          // 如果是PC/H5/APP，则显示对应的数据
          switch (this.channel) {
            case 101:
              dataList = [
                {
                  name: "PC",
                  list: this.currentTypeInfo[0].list,
                },
              ];
              break;
            case 102:
              dataList = [
                {
                  name: "H5",
                  list: this.currentTypeInfo[1].list,
                },
              ];
              break;
            case 103:
              dataList = [
                {
                  name: "APP",
                  list: this.currentTypeInfo[2]?.list || [],
                },
              ];
              break;
          }
        }
      } else {
        return;
      }
      this.showData(dataList);
    },
    // 展示不限渠道的所有数据
    showAllChannel() {
      let dataList = [];
      switch (this.showType) {
        case 2:
          dataList = [
            {
              name: "PC",
              list: this.shopViewCntList[0].list,
            },
            {
              name: "H5",
              list: this.shopViewCntList[1].list,
            },
          ];
          this.currentTypeInfo = this.shopViewCntList;
          this.channelInfo = this.distribution[2];
          break;
        case 5:
          dataList = [
            {
              name: "PC",
              list: this.shopVisitorCntList[0].list,
            },
            {
              name: "H5",
              list: this.shopVisitorCntList[1].list,
            },
          ];
          this.currentTypeInfo = this.shopVisitorCntList;
          this.channelInfo = this.distribution[5];
          break;
        case 6:
          dataList = [
            {
              name: "PC",
              list: this.shopContentViewCntList[0].list,
            },
            {
              name: "H5",
              list: this.shopContentViewCntList[1].list,
            },
            {
              name: "APP",
              list: this.shopContentViewCntList[2]?.list || [],
            },
          ];
          this.currentTypeInfo = this.shopContentViewCntList;
          this.channelInfo = this.distribution[6];
          break;
        case 7:
          dataList = [
            {
              name: "PC",
              list: this.shopContentVisitorCntList[0].list,
            },
            {
              name: "H5",
              list: this.shopContentVisitorCntList[1].list,
            },
            {
              name: "APP",
              list: this.shopContentVisitorCntList[2]?.list || [],
            },
          ];
          this.currentTypeInfo = this.shopContentVisitorCntList;
          this.channelInfo = this.distribution[7];
          break;
      }
      return dataList;
    },
    // 获取图表相关数据
    async queryList() {
      this.loading = true;
      const { result } = await this.$axios.post(
        api.dataAnalysis.getTrafficData,
        {
          from: this.queryParams.from,
          to: this.queryParams.to,
        }
      );
      if (result) {
        const {
          shopViewCnt,
          shopViewCntList,
          shopVisitorCnt,
          shopVisitorCntList,
          shopContentViewCnt,
          shopContentViewCntList,
          shopContentVisitorCnt,
          shopContentVisitorCntList,
        } = result;
        this.shopViewCnt = shopViewCnt;
        this.shopViewCntList = shopViewCntList;
        this.shopVisitorCnt = shopVisitorCnt;
        this.shopVisitorCntList = shopVisitorCntList;
        this.shopContentViewCnt = shopContentViewCnt;
        this.shopContentViewCntList = shopContentViewCntList;
        this.shopContentVisitorCnt = shopContentVisitorCnt;
        this.shopContentVisitorCntList = shopContentVisitorCntList;
        // 数据统计模块展示的数据
        this.showInfo = [
          this.shopViewCnt,
          this.shopVisitorCnt,
          this.shopContentViewCnt,
          this.shopContentVisitorCnt,
        ];
        // 渠道饼状图渲所有渲染数据
        this.distribution = {
          // 店铺浏览量
          2: {
            PC: shopViewCntList[0].count,
            H5: shopViewCntList[1].count,
          },
          // 店铺访客数
          5: {
            PC: shopVisitorCntList[0].count,
            H5: shopVisitorCntList[1].count,
          },
          // 内容访客数
          6: {
            PC: shopContentViewCntList[0].count,
            H5: shopContentViewCntList[1].count,
            APP: shopContentViewCntList[2]?.count || 0,
          },
          // 内容浏览量
          7: {
            PC: shopContentVisitorCntList[0].count,
            H5: shopContentVisitorCntList[1].count,
            APP: shopContentVisitorCntList[2]?.count || 0,
          },
        };
      }
      this.loading = false;
    },
    // 渲染图表信息
    showData(dataList) {
      // 判断是否已经存在实例 避免重复注册
      let myChart = echarts.getInstanceByDom(document.getElementById("main"));
      if (!myChart) {
        myChart = echarts.init(document.getElementById("main"));
      }
      // var option;
      let option = {
        // 设置图表标题信息
        title: {
          text: "趋势图", // 图表文字
          left: "5%", // 图表标题位置
        },
        tooltip: {
          trigger: "axis", // 触发类型
        },
        // 设置x轴坐标信息
        xAxis: {
          data: dataList[0].list.map((item) => item.time),
        },
        // 设置y轴坐标类型为数据轴 适用于连续数据 会根据数据自动计算坐标轴的最小值和最大值
        yAxis: { type: "value" },
        series: dataList.map((item) => {
          // 遍历数据列表，返回数据对象数组，渲染多条折线
          // 数组中每个对象对应一条折线
          return {
            data: item.list.map((item2) => item2.value), // 具体数据点
            type: "line", // 设置图表类型为折线图
            name: item.name, // 图表名称
            // smooth: true, // 是否将折线设置为平滑曲线
            // 设置折线样式
            itemStyle: {
              color: this.channelColors[item.name], // 折线颜色
            },
          };
        }),
      };
      // 第二个参数默认为 false 即表示合并新旧option 可能会出现某类数据被删除 但对应数据折线依旧存在的问题
      // 设置为 true，表示内部所有组件都会被删除，然后根据新 option 创建所有新组件。
      option && myChart.setOption(option, true);

      // 右侧饼图
      let myChart2 = echarts.getInstanceByDom(
        document.getElementById("circular")
      );
      if (!myChart2) {
        myChart2 = echarts.init(document.getElementById("circular"));
      }
      let option2 = {
        title: {
          text: "分布图",
          left: "5%",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          // 底部图例说明
          bottom: 0,
          left: "center",
          data: Object.keys(this.channelInfo),
        },
        series: [
          {
            type: "pie",
            radius: ["45%", "70%"],
            minAngle: 5, // 数据项占有的最小角度
            emphasis: {
              // 鼠标hover的高亮样式
              scale: true,
              scaleSize: 10,
            },
            data: [
              {
                value: this.channelInfo.PC,
                name: `PC`,
                label: {
                  formatter: "{b} {d}%",
                  color: "#333",
                  fontSize: this.channel === 101 ? 14 : 12,
                  fontWeight: this.channel === 101 ? "bold" : "normal",
                },
                labelLine: {
                  lineStyle: {
                    width: this.channel === 101 ? 2 : 1,
                  },
                },
                itemStyle: {
                  color: this.channelColors["PC"],
                  opacity:
                    this.channel === 101 || this.channel === 100 ? 1 : 0.4,
                },
              },
              {
                value: this.channelInfo.H5,
                name: "H5",
                label: {
                  formatter: "{b} {d}%",
                  color: "#333",
                  fontSize: this.channel === 102 ? 14 : 12,
                  fontWeight: this.channel === 102 ? "bold" : "normal",
                },
                labelLine: {
                  lineStyle: {
                    width: this.channel === 102 ? 2 : 1,
                  },
                },
                itemStyle: {
                  color: this.channelColors["H5"],
                  opacity:
                    this.channel === 102 || this.channel === 100 ? 1 : 0.4,
                },
              },
              {
                value: this.channelInfo.APP,
                name: "APP",
                label: {
                  formatter: "{b} {d}%",
                  color: "#333",
                  fontSize: this.channel === 103 ? 14 : 12,
                  fontWeight: this.channel === 103 ? "bold" : "normal",
                },
                labelLine: {
                  lineStyle: {
                    width: this.channel === 103 ? 2 : 1,
                  },
                },
                itemStyle: {
                  color: this.channelColors["APP"],
                  opacity:
                    this.channel === 103 || this.channel === 100 ? 1 : 0.4,
                },
              },
            ],
          },
        ],
      };
      option2 && myChart2.setOption(option2, true);
      // 如果选中的不是不限 手动设置一下当前选中的高亮效果
      if (this.channel !== 100) {
        // 取消指定的高亮
        myChart2.dispatchAction({
          type: "downplay",
        });
        // 重新设置高亮
        myChart2.dispatchAction({
          type: "highlight",
          // 用 name 来指定数据项。
          name: this.channelName,
        });
      } else {
        // 如果选中的是不限 取消指定的高亮
        myChart2.dispatchAction({
          type: "downplay",
        });
      }
    },
    // 导出数据
    exportList() {
      let dataType = 1;
      switch (this.showType) {
        case 2:
          dataType = 1;
          break;
        case 5:
          dataType = 2;
          break;
        case 6:
          dataType = 3;
          break;
        case 7:
          dataType = 4;
          break;
      }
      window.open(
        `https://shopcenter.xkw.com/${api.dataAnalysis.exportData}?from=` +
          this.queryParams.from +
          "&to=" +
          this.queryParams.to +
          "&shopId=" +
          this.$store.state.user.userInfo.shopId +
          "&dataType=" +
          dataType +
          "&shopType=" +
          this.$store.state.user.userInfo.shopTypeId
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.traffic-page {
  width: 100%;
  height: 100%;
  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  // background: #fff;
  .result-container {
    padding: 54px 20px 40px;
    background: #fff;
    border-radius: 5px;
    .echarts-box {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      margin-top: 60px;
      #main {
        width: 60%;
        height: 350px;
      }
      #circular {
        width: 30%;
        height: 300px;
      }
    }
  }
}
</style>
